export enum Brand {
  Very = "very",
  VeryIE = "veryireland",
  Littlewoods = "littlewoods",
}

// Type for all possible brand values in our application
export type BrandValue = `${Brand}`;

// Type mapping for Fuse Design System brands
export type FuseBrand = "very" | "littlewoods" | "veryireland";
